import type { TypedStartListening } from '@reduxjs/toolkit';
import { createListenerMiddleware } from '@reduxjs/toolkit';

import { SLOW_selectEmissionsMapViewState } from '../reducers/pages/emissions-map/selectors/viewStateSelectors';
import {
    decreaseEmissionsMapViewStateZoom,
    increaseEmissionsMapViewStateZoom
} from '../reducers/pages/emissions-map/slices/viewStateSlice';
import type { AppDispatch, RootState } from '../store';
import { analytics } from '../utils';

// Create the middleware instance and methods
export const analyticsMiddleware = createListenerMiddleware();

// Help from https://redux-toolkit.js.org/api/createListenerMiddleware#typescript-usage
const startAnalyticsListening = analyticsMiddleware.startListening as TypedStartListening<RootState, AppDispatch>;

startAnalyticsListening({
    actionCreator: decreaseEmissionsMapViewStateZoom,
    effect: ({ payload }, listenerApi) => {
        const currentZoom = SLOW_selectEmissionsMapViewState(listenerApi.getOriginalState()).zoom;
        analytics.clickZoom({ direction: 'out', zoom: Math.floor(currentZoom - payload) });
    }
});

startAnalyticsListening({
    actionCreator: increaseEmissionsMapViewStateZoom,
    effect: ({ payload }, listenerApi) => {
        const currentZoom = SLOW_selectEmissionsMapViewState(listenerApi.getOriginalState()).zoom;
        analytics.clickZoom({ direction: 'in', zoom: Math.floor(currentZoom + payload) });
    }
});
